import { AxiosError } from "axios";

import { getUserInternalAccessToken } from "@/api/access-token-backoffice";
import { getCustomerId } from "@/helpers/auth-helpers";
import { ICustomerPlatform } from "@/interfaces/customer-platform.interfaces";
import { apiT2B } from "@/lib/axios";

const baseCustomerPlatformUrl = "api/v1/customerplatform";

function normalizeCustomerPlatformActive(item: Record<string, unknown>): boolean {
  const raw = item.Active ?? item.active;
  if (raw === false || raw === 0 || raw === "0") return false;
  if (typeof raw === "string" && raw.toLowerCase() === "false") return false;
  return true;
}

export async function getCustomerPlatforms() {
  try {
    // Get internal access token (simula o Next.js Route Handler)
    const { accessToken: internalAccessToken } = await getUserInternalAccessToken();

    // Get current user's customer ID
    const customerId = getCustomerId();

    if (!customerId) {
      throw new Error("Customer ID not found");
    }

    const config = {
      headers: {
        Authorization: `Bearer ${internalAccessToken}`,
        CustomerId: customerId,
      },
    };

    // Usar a mesma URL que o Next.js usa: /api/v1/customerplatform com paginação
    const paginationQuery = "pageNumber=1&pageSize=20";
    const apiUrl = `${baseCustomerPlatformUrl}?${paginationQuery}`;

    const response = await apiT2B.get(apiUrl, config);

    // O Next.js retorna response.data.items, então vamos fazer o mesmo
    const items = response.data.items || response.data;

    // Sanitizar dados como no Next.js (remover campos sensíveis)
    const sanitizedItems = Array.isArray(items)
      ? items.map((item: Record<string, unknown>) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { recoveryCode, refreshToken, configuration, ...rest } = item;
          const Active = normalizeCustomerPlatformActive(rest);
          return { ...rest, Active } as ICustomerPlatform;
        })
      : [];

    return sanitizedItems as ICustomerPlatform[];
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Failed to fetch customer platforms");
    }
    throw new Error("Failed to fetch customer platforms");
  }
}
